import { AllowedAccess } from 'react-permission-role'
import { useLocation, useParams } from 'react-router-dom'
import { Card, CardContent, Grid } from '@mui/material'

import { useFechInitLeases } from './hooks'
import { LegalAppliesForm } from './LegalAppliesForm'
import { AppliesTable } from './LegalAppliesTable'
import { LinearLoading } from 'common'

export const LegalLeasesApplies = () => {

    const location = useLocation();
    const paramsURL = useParams();
    const useFetchInit = useFechInitLeases({location, paramsURL})

    const {
        globalStates,
        FetchData,
    } = useFetchInit

    // ------------------------------------------------ Generales
    // ------------------------------------------------ globalStates
    const { showForm} = globalStates
    const {fetchAllLeaseApplications } = FetchData
    const { loadingFetchLeaseApplications} = fetchAllLeaseApplications

    return (
        <AllowedAccess permissions={['115_ARRENDAMIENTOS_SOLICITUDES']} renderAuthFailed={<p>Error</p>}>
            {(!showForm) && (
                <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                        <Card style={{zIndex:'1'}}>
                            <CardContent>
                                <div className='h4 mt-1 mb-1'> Arrendamientos solicitudes</div>
                                <div className="border-bottom border-dark"></div>
                                {loadingFetchLeaseApplications && ( <LinearLoading /> )}
                                <div className="pt-4"></div>
                                    <AppliesTable useFetchInit={useFetchInit} />
                            </CardContent>
                        </Card>
                    </Grid>
                </Grid>
            )}
            {(showForm) && (
                <LegalAppliesForm useFetchInit={useFetchInit} />
            )}
        </AllowedAccess>
    )
}
